/** 浏览器/Web 员工端：从当前页面域名推导 API 基址（含 /api 后缀）。 */
export function getBrowserApiUrl() {
    if (typeof window === 'undefined') {
        return 'http://localhost:8851/api';
    }
    const injected = window.env?.API_URL?.trim();
    if (injected) {
        const t = injected.replace(/\/+$/, '');
        return t.endsWith('/api') ? t : `${t}/api`;
    }
    const { hostname, protocol } = window.location;
    if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://localhost:8851/api';
    }
    if (hostname.startsWith('staff.')) {
        const apex = hostname.slice('staff.'.length);
        return `${protocol}//api.${apex}/api`;
    }
    if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
        return `${protocol}//${hostname}:8851/api`;
    }
    const parts = hostname.split('.');
    if (parts.length >= 2) {
        const apex = parts.slice(-2).join('.');
        return `${protocol}//api.${apex}/api`;
    }
    return `${protocol}//${hostname}:8851/api`;
}
export function getBrowserApiOrigin() {
    const url = getBrowserApiUrl().replace(/\/+$/, '');
    return url.endsWith('/api') ? url.slice(0, -4) : url;
}
